import { createContext } from 'react';
import NotificationsStore from './Store';

export const NotificationsContext = createContext(new NotificationsStore());
